import {
	CHANGE_ACTIVE_TAB,
	CHANGE_OVERVIEW_POLICY_FIELD, CHANGE_OVERVIEW_TAB_READ_MORE_STATE, CHECK_USER_OVERVIEW_TAB_CHECKBOX,
	FAILED_TO_GET_APPLICATION_OVERVIEW, LOGOUT,
	OVERVIEW_POLICY_ATTACHMENTS_CHANGE,
	OVERVIEW_TAB_PAGE_SHIFT,
	RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM, RECEIVE_GET_APPLICATION_OVERVIEW, RECEIVE_POST_OVERVIEW_POLICY_FORM,
	REQUEST_GET_APPLICATION_OVERVIEW,
	REQUEST_POST_OVERVIEW_POLICY_FORM
} from "../actions/index";
import {
    ADD_ANOTHER_OVERVIEW_ATTACHMENT, CHANGE_OVERVIEW_ATTACHMENT,
    GET_OVERVIEW_TAB_TAGS_DESCRIPTION, GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL,
    GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS, REMOVE_OVERVIEW_ATTACHMENT
} from "../actions";

const defaultState = {
    fetching: false,
    comments: '',
    posting: false,
    attachment: {},
    attachments: [
		{attachment: {}, tags: ''}
	],
    badResponse: '',
    badMsg: '',
    tags: '',
    msg: '',
    applicationOverview: [],
    readMore: {},
    uploadLabel: 'Drag and drop.',
    page: 1,
    totalBoxes: 1,
    sendEmailNotification: false,
	tagsDescription: '',
	fetchingTagsDescription: false,
	fetchingOverviewErrorMessage: ''
};


export default (state = defaultState, action) => {
	switch (action.type) {
		case CHANGE_OVERVIEW_ATTACHMENT:
			let attch = state.attachments.map(a => ({attachment: {...a.attachment}, tags: a.tags}));
            attch[action.payload.attachmentIndex][action.payload.key] = action.payload.value;
			return {
				...state,
                attachments: attch
			};
		case REMOVE_OVERVIEW_ATTACHMENT:
			let overViewAttachments = [...state.attachments];
            overViewAttachments.splice(action.payload.attachmentIndex, 1);
			return {
				...state,
				attachments: overViewAttachments
			};
		case ADD_ANOTHER_OVERVIEW_ATTACHMENT:
			return {
				...state,
				attachments: [...state.attachments, {attachment: {}, tags: ''}]
			};
		case GET_OVERVIEW_TAB_TAGS_DESCRIPTION:
			return {
				...state,
				fetchingTagsDescription: true
			};
		case GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS:
		    let tagsDes;
		    try {
		        tagsDes = action.payload.body.body;
            }
            catch (e){ tagsDes = ''}
			return {
				...state,
				fetchingTagsDescription: false,
                tagsDescription: tagsDes
			};
		case GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL:
			return {
				...state,
				fetchingTagsDescription: false
			};
		case CHECK_USER_OVERVIEW_TAB_CHECKBOX:
			let newSendEmailNotification = state.sendEmailNotification;
			if(action.payload !=="all"){
				newSendEmailNotification = false;
			}
			return {
				...state,
				badMsg: '',
				msg: '',
        sendEmailNotification: newSendEmailNotification
			};
		case OVERVIEW_TAB_PAGE_SHIFT:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
				return {
					...state,
					page: state.page + 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else return {
					...state,
					totalBoxes: action.payload.totalPaginationBoxes
				};
		case RECEIVE_GET_APPLICATION_OVERVIEW:
			let readMore = {};
			try {
				action.payload.forEach(element => {
					readMore = {...readMore, [element.id]: false}
				})
			} catch (e) {
				readMore = {};
			}
			return {
				...state,
				applicationOverview: action.payload,
				readMore: readMore,
				fetching: false
			};
		case REQUEST_GET_APPLICATION_OVERVIEW:
			return {
				...state,
				fetching: true,
                fetchingOverviewErrorMessage: defaultState.fetchingOverviewErrorMessage
			};
		case FAILED_TO_GET_APPLICATION_OVERVIEW:
			let failToGetApplicationOverviewMessages = '';
			try {
                failToGetApplicationOverviewMessages = action.payload.response.body.message
			} catch (e) {
                failToGetApplicationOverviewMessages = 'Failed to fetch overview comments. Please try again later';
            }
			return {
				...state,
				fetching:false,
                fetchingOverviewErrorMessage: failToGetApplicationOverviewMessages
			};
		case CHANGE_OVERVIEW_POLICY_FIELD:
			if (action.payload.key === 'badMsg')
				return {
					...state,
					msg: '',
					badMsg: action.payload.value
				};
			return {
				...state,
				[action.payload.key]: action.payload.value,
				msg: '',
				badMsg: ''
			};
		case CHANGE_OVERVIEW_TAB_READ_MORE_STATE:
			return {
				...state,
				readMore: {...state.readMore, [action.payload.key]: action.payload.value},
			};
		case REQUEST_POST_OVERVIEW_POLICY_FORM:
			return {
				...state,
				posting: true,
                badMsg: defaultState.badMsg
			};
		case RECEIVE_POST_OVERVIEW_POLICY_FORM:
			return {
				...state,
				posting: false,
				msg: 'Sent Successfully.',
				comments: '',
				attachment: {},
				attachments: defaultState.attachments,
				tags: '',
				uploadLabel: 'Drag and drop.',
				sendEmailNotification: false
			};
		case RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM:
			let overviewPostErrorMessage = '';
			try {
                overviewPostErrorMessage = action.payload.response.message
			} catch (e) {
                overviewPostErrorMessage = 'Failed to create comment. Please try again later.'
            }
			return {
				...state,
				posting: false,
				badMsg: overviewPostErrorMessage,
				sendEmailNotification: false
			};
		case OVERVIEW_POLICY_ATTACHMENTS_CHANGE: {
			return {
				...state,
				attachment: action.payload,
				uploadLabel: action.payload.name,
				msg: '',
				badMsg: ''
			}
		}
		case CHANGE_ACTIVE_TAB:
			return {
				...state,
				msg: '',
				badMsg: '',
				sendEmailNotification: defaultState.sendEmailNotification
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case '@@router/LOCATION_CHANGE':
			return {
				...defaultState
			};
		default :
			return state
	}
}